import { Creator } from '~/clientApi/creator.model';
import { getMainPlatformData } from '~/creatorUtils';
import {
  getCreatorPlatformConnectionStatus,
  getInstagramStatus,
  getTiktokStatus,
  getYoutubeStatus,
} from '~/utils';

interface State {
  creator: Creator | null;
}

export const selectInstagramStatus = ({ creator }: State) =>
  getInstagramStatus(creator as Creator);

export const selectTiktokStatus = ({ creator }: State) =>
  getTiktokStatus(creator as Creator);

export const selectYoutubeStatus = ({ creator }: State) =>
  getYoutubeStatus(creator as Creator);

export const selectSocialPlatformsConnectionStatus = ({ creator }: State) =>
  getCreatorPlatformConnectionStatus(creator as Creator);

export const selectCreatorMainPlatformData = ({ creator }: State) =>
  getMainPlatformData(creator as Creator);

export const selectCreator = (state: State) => state.creator;
